import { TFunction } from '@lyearn/i18n';
import { Menu3Outline, ShuffleOutline } from '@lyearn/icons';
import { SingleSelectItem } from '@/components/FilterManager/types';

export enum SubtaskViewType {
  NestedList = 'NestedList',
  Expanded = 'Expanded',
  Separate = 'Separate',
}

const SUBTASK_FILTER_ITEMS = [
  {
    // id: SubtaskViewType.Collapsed, //todo: replace this with subtaskViewType
    id: SubtaskViewType.NestedList,
    labelKey: 'Common:Filter.NestedList',
    Icon: Menu3Outline,
    value: SubtaskViewType.NestedList,
  },
  // {
  //   // id: SubtaskViewType.Expanded,
  //   id: SubtaskViewType.Expanded,
  //   labelKey: 'Common:Filter.Expanded',
  //   Icon: ExpandOutline,
  //   value: SubtaskViewType.Expanded,
  // },
  {
    id: SubtaskViewType.Separate,
    labelKey: 'Common:Filter.Separate',
    Icon: ShuffleOutline,
    value: SubtaskViewType.Separate,
  },
];

export const DEFAULT_SUBTASK_VIEW = SubtaskViewType.NestedList;

export const SUBTASK_VIEW_VALUES = SUBTASK_FILTER_ITEMS.map((item) => item.value);

export const getSubtasksViewItems = (t: TFunction): SingleSelectItem[] =>
  SUBTASK_FILTER_ITEMS.map(({ Icon, id, labelKey, value }) => ({
    id,
    icon: <Icon className="h-20 w-20" />,
    label: t(labelKey),
    value,
  }));
